<template>
  <span class="hint"><slot /></span>
</template>
